import script from "./PlanParticularCommentsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanParticularCommentsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PlanParticularCommentsPopup.vue?vue&type=style&index=0&id=d886f58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d886f58a"]])

export default __exports__